import { all, call, fork } from "redux-saga/effects";
import { watcherForCartSaga } from "./cartSaga";
import { watcherFetchCommonSaga } from "./commonSaga";
import watchLocationLockSaga from "./locationLock";
import {
  watcherFetchDeliveryDateSaga,
  watcherFetchProductListFilterForMobile,
  watcherFetchProductListingSaga,
  watcherFiltersSaga,
} from "./plpSaga";
import { watcherGiftFinderSaga } from "./giftFinderSaga";
import { watcherFetchWebFeatureControls } from "./webFeatureControls";
import watchPdpSaga from "./pdpSaga";
import { watcherShippingDateAndSlotSelectionSaga } from "./commonSaga/ShippingDateAndSlotSelection";
import watcherLoginFlowSaga from "./loginSaga";
import { watcherAddOnSaga } from "./commonSaga/addOn";
import watchFnpCashSaga from "./fnpCashSaga";
import { watcherSecretSanta } from "./secretSantaSaga";
import { watchDynamicHomeSaga } from "./dynamicHomeSaga";
import watchDeliveryAddressSaga from "./deliveryAddressSaga";
import watchMyAccountSaga from "./myAccountSaga";
import watchAccountAddressBookSaga from "./accountAddressBookSaga";
import watchOrderModificationSaga from "./orderModificationSaga";
/**
 * Root saga function that combines and forks multiple watcher sagas.
 *
 * @export
 * @generator
 * @function rootSaga
 * @yields {void}
 */
export default function* rootSaga() {
  yield all([
    fork(watcherForCartSaga),
    fork(watcherFetchDeliveryDateSaga),
    fork(watcherFetchProductListingSaga),
    fork(watcherGiftFinderSaga),
    fork(watcherFetchWebFeatureControls),
    fork(watcherFetchCommonSaga),
    fork(watchLocationLockSaga),
    fork(watchPdpSaga),
    fork(watcherShippingDateAndSlotSelectionSaga),
    fork(watcherLoginFlowSaga),
    fork(watcherAddOnSaga),
    fork(watcherFiltersSaga),
    fork(watchFnpCashSaga),
    fork(watcherFetchProductListFilterForMobile),
    fork(watcherSecretSanta),
    fork(watchDynamicHomeSaga),
    call(watchDeliveryAddressSaga),
    fork(watchMyAccountSaga),
    fork(watchAccountAddressBookSaga),
    fork(watchOrderModificationSaga),
  ]);
}
